import { Injectable, signal } from '@angular/core';

export type TipoAviso = 'info' | 'exito' | 'alerta';

export interface Aviso { texto: string; tipo: TipoAviso; id: number }

/**
 * Un aviso corto y global (se pinta en MainLayout, arriba al centro): «Cambiamos a Obra B porque tienes acceso a ella en este módulo». No es
 * el toast rojo de acceso denegado (PermisosService) ni la campana de notificaciones: es para decirle a la persona algo que el portal hizo por ella.
 */
@Injectable({ providedIn: 'root' })
export class AvisoService {
  readonly actual = signal<Aviso | null>(null);
  private seq = 0;
  private timer: ReturnType<typeof setTimeout> | null = null;

  mostrar(texto: string, tipo: TipoAviso = 'info', duracionMs = 5000): void {
    if (this.timer) clearTimeout(this.timer);
    const id = ++this.seq;
    this.actual.set({ texto, tipo, id });
    this.timer = setTimeout(() => { if (this.actual()?.id === id) this.actual.set(null); }, duracionMs);
  }

  cerrar(): void {
    if (this.timer) clearTimeout(this.timer);
    this.actual.set(null);
  }
}
